import React, {useContext} from 'react';
import {CustomerDataContext} from "../../components/context/CustomerDataProvider";
import LoggedOut from "./LoggedOut";
import LoggedIn from "./LoggedIn";
import {Container} from "@mui/material";
import { AppState } from '../../types/types';

interface Props {
    appState: AppState
}

const Account : React.FC<Props> = ({appState}) => {
    const {customer} = useContext(CustomerDataContext);
    console.log("Customer", customer)
    return <Container maxWidth="lg" >
        {customer ? <LoggedIn appState={appState} /> : <LoggedOut />}
    </Container>
}

export default Account;